import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import eyeOpen from "../assets/eyeOpen.png"; // Image for "show password"
import eyeClosed from "../assets/eyeClosed.png"; // Image for "hide password"

const PasswordField = ({ title, placeholder, isRequired, onChange, value }) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <label>
        {title} {isRequired && <span className="required">*</span>}
      </label>
      <TextField
        fullWidth
        // label={title} // Set the label as the title prop
        placeholder={placeholder} // Set the placeholder prop
        required={isRequired} // Set whether the field is required
        type={showPassword ? "text" : "password"} // Toggle between text and password types
        value={value} // Controlled component
        onChange={onChange} // Handle changes
        sx={{ marginBottom: 4, width: 500 }}
        InputProps={{
          // Input adornment for the eye icon
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={toggleShowPassword} edge="end">
                <img
                  src={showPassword ? eyeClosed : eyeOpen} // Switch image based on state
                  alt={showPassword ? "Hide password" : "Show password"}
                  style={{ cursor: "pointer", width: "20px" }} // Optional styling
                />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default PasswordField;
